"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OfferHintsModal = void 0;
var _components = require("@ori-ui/components");
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _hooks = require("../../hooks");
var _OfferHint = require("../OfferHint");
var _jsxRuntime = require("react/jsx-runtime");
const Root = (0, _mui.styled)(_components.Dialog)(({
  theme
}) => ({
  [`& .${_components.dialogClasses.dialogGrid}`]: {
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      width: `calc(100vw - ${theme.spacing(6)})`
    },
    [theme.breakpoints.up('md')]: {
      width: `calc(100vw - ${theme.spacing(12)})`
    }
  }
}));

// not sure about purpose of ref that is passed all over
// div element with id offer-hints-modal-content is useless for dialog and kept only because of the test-id

const OfferHintsModal = ({
  isOpen,
  offers,
  onClose
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const dialogRef = /*#__PURE__*/(0, _react.createRef)();
  const {
    formatMessage
  } = (0, _hooks.useTranslations)();
  const header = formatMessage('yourOffers');
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(Root, {
    closeAfterTransition: true,
    "data-testid": getTestId('offer-hints-modal'),
    header: header,
    maxWidth: "768px",
    open: isOpen,
    onClose: onClose,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      ref: dialogRef,
      "data-testid": getTestId('offer-hints-modal-content'),
      children: offers.map(offer => /*#__PURE__*/(0, _jsxRuntime.jsx)(_OfferHint.OfferHint, {
        dialogRef: dialogRef,
        offer: offer
      }, offer.offerId))
    })
  });
};
exports.OfferHintsModal = OfferHintsModal;